import {
  getConzBatchHistogram,
  getConzViabBatchHistogram,
} from '@/features/single-measurement/services/batches';
import { IBatch, Method } from '@/features/single-measurement/types';

export const getHistogramGraph = async (batch: IBatch) => {
  if (
    [Method.WineConzViab, Method.Yeast2ConzViab, Method.BioEthConzViab].includes(
      batch.method,
    )
  )
    return getConzViabBatchHistogram(batch);

  if ([Method.WineConz, Method.Yeast2Conz, Method.BioEthConzViab].includes(batch.method))
    return getConzBatchHistogram(batch);
};
